import { getLocalApi } from "./localApi";
import { DiscountDto } from "app/shared/model/DiscountDto";
import { DiscountType } from "app/shared/model/DiscountType";
import apiConfig from "app/api/apiConfig.json";

export async function getDiscount(id: string) {
    const localApi = await getLocalApi();
    return await localApi.fetchSingle(apiConfig.discounts_get_by_id.replace("{id}", encodeURIComponent(id)), mapDiscount, 'Error fetching discount');
}

export async function getBlankDiscount(type: DiscountType) {
    const localApi = await getLocalApi();

    return await localApi.fetchSingle(apiConfig.discounts_get_by_type + '?type=' + encodeURIComponent(type), mapDiscount, 'Error fetching discount');
}

function mapDiscount(dto: any) {
    return dto as DiscountDto;
}